'use client';

import { stack } from '@flipster/styled-system/patterns';

import { HeroSection } from './section/1-hero';
import { SecurityTipsSection } from './section/2-security-tips';
import { FaqSection } from './section/3-faq';

export const ChannelVerificationPage = () => {
  return (
    <main
      className={stack({
        w: '100%',
        mx: 'auto',
        maxW: 'desktopMaxWidth',
        minH: 'minHeightWithoutNavigation',
        px: { base: 16, tablet: 32 },
        py: { base: 32, tablet: 80 },
        gap: 80,
        smallDesktop: { boxSizing: 'content-box' },
      })}
    >
      <HeroSection />
      <SecurityTipsSection />
      <FaqSection />
    </main>
  );
};
